import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'c3m-input-error-msg',
  templateUrl: './input-error-msg.component.html',
  styleUrls: ['./input-error-msg.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class InputErrorMsgComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
